import { Group, Text, ThemeIcon } from '@mantine/core';
import { forwardRef } from 'react';

const ChannelSelectItem = forwardRef(({ label, icon, color, labelClass, ...others }, ref) => (
    <div ref={ref} {...others}>
        <Group noWrap spacing='xs'>
            <ThemeIcon size='sm' variant='light' color={color}>
                {icon}
            </ThemeIcon>
            <Text size='sm' className={labelClass}>{label}</Text>
        </Group>
    </div>
));

ChannelSelectItem.displayName = 'ChannelSelectItem';

export default ChannelSelectItem;
